module.exports = __webpack_public_path__ + "img/404.e19620f9.png";